@if(this.aantalValidatiesValue > 0) {
  <snelstart-ui-alert type="warning">
    Het toeslagenformulier bevat nog validatiemeldingen. Hierdoor kan er mogelijk geen berekening worden gemaakt.
  </snelstart-ui-alert>
}

<form [formGroup]="totalenFG">
  <div>
    <div class="row">
      <div class="col col-1 pt-3">
        <p>Zorgtoeslag</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="zorg3"
                                          label="Recht op toeslag"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="zorg2"
                                          label="Ontvangen voorschot"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <div *ngIf="this.zorg <= 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="zorg1"
                                            label="Resteert"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div *ngIf="this.zorg > 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="zorg1"
                                            label="Resteert"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
        <div class="col-4"></div>
    </div>
  </div>
  <div>
    <div class="row">
      <div class="col col-1">
        <p>Kindgebonden budget</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="kgb3"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="kgb2"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <div *ngIf="this.kgb <= 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="kgb1"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div *ngIf="this.kgb > 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="kgb1"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
        <div class="col-4"></div>
    </div>
  </div>
  <div>
    <div class="row">
      <div class="col col-1">
        <p>Kinderopvangtoeslag</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="kot3"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="kot2"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <div *ngIf="this.kot <= 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="kot1"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div *ngIf="this.kot > 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="kot1"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
        <div class="col-4"></div>
    </div>
  </div>
  <div>
    <div class="row">
      <div class="col col-1">
        <p>Huurtoeslag</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="huur3"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="huur2"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <div *ngIf="this.huur <= 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="huur1"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div *ngIf="this.huur > 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="huur1"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
        <div class="col-4"></div>
    </div>
  </div>
</form>
<form [formGroup]="totalenFG">
  <div>
    <div class="row">
      <div class="col col-1">
        <b *ngIf="this.saldo <= 0">Te ontvangen</b>
        <b *ngIf="this.saldo > 0">Te betalen</b>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="sumToeslagen"

                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 custom-readonly"
                                          formControlName="sumVoorschot"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-4">
        <div *ngIf="this.saldo <= 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="sumSaldo"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div *ngIf="this.saldo > 0">
          <snelstart-ui-number-form-control [showAllDecimals]="false"
                                            align="right"
                                            class="custom-input-150 custom-readonly"
                                            formControlName="sumSaldo"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
        <div class="col-4"></div>
    </div>
  </div>
</form>
